import React, { useState } from 'react';
import { StarIcon, ArrowLeftIcon, ArrowRightIcon, ExternalLinkIcon } from 'lucide-react';
import { Norden } from './Norden';

// Vul hier de URL van het Google Bedrijfsprofiel in.
// Zolang dit leeg is, wordt de knop naar Google niet getoond.
const GOOGLE_REVIEWS_URL = '';
type Review = {
  name: string;
  company: string;
  rating: number;
  text: string;
  source: 'google' | 'direct';
};

// LET OP, CONTROLEER DIT VOOR DE SITE ECHT LIVE GAAT
// De reviews met source 'google' zijn overgenomen uit het Google
// Bedrijfsprofiel. Ze zijn daar door Google naar het Engels vertaald en
// hier weer naar het Nederlands teruggezet. De strekking klopt, maar de
// bewoording kan afwijken van wat de klant oorspronkelijk schreef.
// Leg ze naast de Nederlandse originelen in je Bedrijfsprofiel en pas aan
// waar nodig. Een review is een citaat, dus die moet woordelijk kloppen.
const reviews: Review[] = [{
  name: 'toucan man',
  company: 'Ondernemer',
  rating: 5,
  text: 'Toppers, ze hebben in no time een website voor me opgezet. Ik ben al een tijd ondernemer en heb met veel marketing- en websitebureaus gewerkt, maar dit is in alle opzichten de beste.',
  source: 'google'
}, {
  name: 'Familie Wienema',
  company: 'Google review',
  rating: 5,
  text: 'Uitstekende service en resultaat. Dit bedrijf heeft niet alleen de vindbaarheid van mijn website in zoekmachines verbeterd, maar hem ook voorzien van een strak en professioneel ontwerp.',
  source: 'google'
}, {
  name: 'Jayden',
  company: 'Eigenaar webshop',
  rating: 5,
  text: 'Nadat ik bij een ander bedrijf een website voor mijn webshop had laten bouwen ging het compleet mis. Ik moest veel betalen en kreeg weinig resultaat. Toen raadde een vriend Noord Digital aan, en wat een verschil.',
  source: 'google'
}, {
  name: 'Leonie Tieken',
  company: 'Google review',
  rating: 5,
  text: 'Nadat ik door een ander bedrijf was opgelicht hebben deze jongens mij enorm goed geholpen met een prachtige website. Ik ben er zo dankbaar voor.',
  source: 'google'
}, {
  name: 'Mats Steenhuis',
  company: 'Eigenaar SteenhuisVisuals',
  rating: 5,
  text: 'Ik heb door deze jongens een website laten maken voor mijn nieuwe bedrijf. Na snelle communicatie kwamen zij al snel tot een concept, dit sloeg direct aan waarna wij in zee zijn gegaan met elkaar. Als eindresultaat een prachtige website. 5 van de 5 sterren.',
  source: 'google'
}, {
  name: 'Carla van Hilten-Deuzeman',
  company: 'Eigenaar metcarla.nl',
  rating: 5,
  text: 'Superblij ben ik met mijn website. Wat begon als een droom, krijgt nu gestalte. Samen met Noord Digital hebben we gebrainstormd, nagedacht, geschaafd en geschreven om een website te maken die uitstraalt wie ik ben. Snel schakelen, meedenken, vriendelijk en gewoon heel erg aardig. Ik kan ze van harte aanbevelen.',
  source: 'direct'
}, {
  name: 'Justin Nijholt',
  company: 'Google review',
  rating: 5,
  text: 'Uiterst tevreden met het resultaat. Ze dachten proactief mee en leverden een professionele website op. Snelle communicatie, duidelijke afspraken en topkwaliteit. Een aanrader.',
  source: 'google'
}, {
  name: 'Werner Tausendfreund',
  company: 'Google review',
  rating: 5,
  text: 'Ik ben uitstekend geholpen. Ze luisteren goed naar onze wensen en komen met goede, professionele oplossingen. Supervriendelijk en ze reageren snel.',
  source: 'google'
}, {
  name: 'Akin Yucel',
  company: 'Google review',
  rating: 5,
  text: 'Erg blij met mijn nieuwe website. Goede communicatie, snel werk en het resultaat ziet er professioneel uit. Ik raad het zeker aan aan iedereen die een website wil laten bouwen.',
  source: 'google'
}, {
  name: 'Nicola de Roode',
  company: 'Eigenaar AS Family Fitness Center B.V.',
  rating: 5,
  text: 'Het is zo fijn om te weten dat een website in goede handen is. Korte lijnen, prettig contact, technisch sterk en persoonlijk betrokken. Wat voelt als een verlengstuk van ons team, een aanrader!',
  source: 'direct'
}, {
  name: 'Sanne-Isabelle Beekhuis',
  company: 'Google review',
  rating: 5,
  text: 'SUPER ervaring met Noord Digital. Ontzettend professioneel. Goede communicatie, snelle service en een prachtig resultaat.',
  source: 'google'
}, {
  name: 'Floris Holscher',
  company: 'Google review',
  rating: 5,
  text: 'Een jong en gedreven team dat mooie websites maakt, van klein en simpel tot mooi en zeer complex. Hier ben je aan het juiste adres.',
  source: 'google'
}, {
  name: 'Jovanna Vriend',
  company: 'Google review',
  rating: 5,
  text: 'Heel duidelijk en behulpzaam, uitstekende service. Ze bellen je direct terug.',
  source: 'google'
}, {
  name: 'Jens Wiegers',
  company: 'Eigenaar Wiegers Iconic Nutrition',
  rating: 5,
  text: 'De samenwerking met Noord was vanaf het begin al erg prettig. Ze luisterden goed naar mijn wensen, communiceerden duidelijk en stonden altijd open voor feedback. Het eindresultaat is precies wat ik voor ogen had: een website die past bij mijn merk en doelgroep.',
  source: 'direct'
}, {
  name: 'Mano Coolegem',
  company: 'Google review',
  rating: 5,
  text: 'Supervriendelijk en snel. Ze leveren fantastisch werk, denken proactief mee en geven bruikbare tips.',
  source: 'google'
}, {
  name: 'Michiel Bakker',
  company: 'Google review',
  rating: 5,
  text: 'Een jong, enthousiast team. Ze denken proactief mee en komen hun afspraken na.',
  source: 'google'
}, {
  name: "Tommy's Services & Security",
  company: 'Eigenaar',
  rating: 5,
  text: 'Erg blij met de website die ze voor mij hebben gemaakt.',
  source: 'google'
}, {
  name: 'Basar Yuksel',
  company: 'Mede-eigenaar Common Frame Media',
  rating: 5,
  text: 'We are absolutely delighted with our new website. The design fits our wishes perfectly, adjustments were made quickly and communication was always clear and friendly. A great collaboration with an excellent result, highly recommended!',
  source: 'direct'
}, {
  name: 'Nico van Diemen',
  company: 'Google review',
  rating: 5,
  text: 'Aardige en professionele heren. Ze geven helder advies en leveren mooi werk.',
  source: 'google'
}, {
  name: 'Michel Kossen',
  company: 'Google review',
  rating: 5,
  text: 'Een club jonge ondernemers met een moderne en frisse kijk op zakendoen. Een aanrader.',
  source: 'google'
}, {
  name: 'Percy Stoffelen',
  company: 'Google review',
  rating: 5,
  text: 'Ze weten waar ze mee bezig zijn. Altijd vriendelijk en ontzettend behulpzaam.',
  source: 'google'
}, {
  name: 'Pim Dekker',
  company: 'Eigenaar Jaepie-Jaepie',
  rating: 5,
  text: 'Goede service! Snel en makkelijk contact en altijd zo geregeld. Meedenken in oplossingen, ik hou er van!',
  source: 'direct'
}, {
  name: 'Tom Brans',
  company: 'Google review',
  rating: 5,
  text: 'Wat een vriendelijke en professionele club. Hebben mij heel goed geholpen met een paar kleine dingen.',
  source: 'google'
}, {
  name: 'defne akar',
  company: 'Google review',
  rating: 5,
  text: 'It was a pleasure working with the Noord Digital team. They brought our vision into life.',
  source: 'google'
}, {
  name: 'ramona pepping',
  company: 'Google review',
  rating: 5,
  text: 'Vriendelijk en kundig team.',
  source: 'google'
}, {
  name: 'Aiden Floris',
  company: 'Google review',
  rating: 5,
  text: 'Goed geholpen door de jongens van Noord Digital. Bedankt voor de tips.',
  source: 'google'
}];
const PER_PAGE = 2;
export const Reviews: React.FC = () => {
  const [page, setPage] = useState(0);
  const totalPages = Math.max(1, Math.ceil(reviews.length / PER_PAGE));
  const visibleReviews = reviews.slice(page * PER_PAGE, page * PER_PAGE + PER_PAGE);
  const nextPage = () => setPage(p => (p + 1) % totalPages);
  const prevPage = () => setPage(p => (p - 1 + totalPages) % totalPages);
  return <div className="w-full bg-white py-16 md:py-[60px]" data-id="element-637" data-mp="18cwlujwsph7y">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-638" data-mp="18c4rtdiujrjs">
        <div className="max-w-3xl mx-auto text-center mb-6" data-id="element-639" data-mp="1d3wlhwxaude5">
          <h2 className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-640" data-mp="1i2pxtm0unycq">
            Wat onze klanten zeggen
          </h2>
          <p className="text-[#6B7280] mb-6 leading-relaxed text-lg" data-id="element-641" data-mp="1m3jlqfeald5m">
            Van lokale vakmensen tot zorgpraktijken en uitzendbureaus. Onze
            klanten waarderen de korte lijnen, de eerlijke communicatie en het
            feit dat er iemand opneemt als je belt. Lees hieronder wat zij over
            hun ervaring te vertellen hebben.
          </p>
          <div className="relative inline-block" data-id="element-642" data-mp="3sx3raxvn3eop">
            <Norden variant="speechBubble" bubbleText="Onze klanten aan het woord" className="mb-8" data-id="element-643" data-mp="1p96h15rlkqu" />
          </div>
        </div>

        <div className="relative" data-id="element-644" data-mp="3ljcneslvgk6b">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6 items-stretch" data-id="element-645" data-mp="3libcqp8rpzp4">
            {visibleReviews.map((review, index) => <figure key={`${page}-${index}`} className="bg-white rounded-2xl shadow-[0_8px_16px_rgba(0,0,0,0.08)] border border-gray-100 p-6 flex flex-col" data-id="element-646" data-mp="3bloveafnhqru" data-mpi={index}>
                <div className="flex items-center justify-between mb-3" data-id="element-647" data-mp="846oc57pcnsh">
                  <div className="flex" aria-label={`${review.rating} van de 5 sterren`} data-id="element-648" data-mp="82vgnub4yvw3">
                    {[...Array(review.rating)].map((_, i) => <StarIcon key={i} className="h-4 w-4 text-yellow-400 fill-current" aria-hidden="true" data-id="element-649" data-mp="2nvm6g37190xg" data-mpi={i} />)}
                  </div>
                  {review.source === 'google' && <span className="text-xs font-medium text-[#6B7280] bg-[#F7F8FA] border border-gray-200 rounded-full px-2.5 py-1" data-id="element-650" data-mp="96lyennmszg4">
                      via Google
                    </span>}
                </div>
                <blockquote className="text-[#6B7280] mb-4 italic flex-grow text-base leading-relaxed" data-id="element-651" data-mp="j3qatvrodgjq">
                  {review.text}
                </blockquote>
                <figcaption className="mt-auto pt-4 border-t border-gray-100" data-id="element-652" data-mp="sul6fqqt9shu">
                  <p className="font-bold text-[#111827]" data-id="element-653" data-mp="16u2rbv0zkllx">{review.name}</p>
                  <p className="text-sm text-[#6B7280]" data-id="element-654" data-mp="16tb4p9pd9y7s">{review.company}</p>
                </figcaption>
              </figure>)}
          </div>

          {totalPages > 1 && <div className="flex justify-center items-center gap-4 mt-6" data-id="element-655" data-mp="38lzbft17z3sb">
              <button onClick={prevPage} className="p-2 rounded-full bg-[#F7F8FA] hover:bg-[#007AFF] hover:text-white transition-colors flex-shrink-0" aria-label="Vorige reviews" data-id="element-656" data-mp="33ned5z5j2u6i">
                <ArrowLeftIcon className="h-5 w-5" data-id="element-657" data-mp="1o5hosmwmihkw" />
              </button>

              <p className="text-sm text-[#6B7280] tabular-nums" data-id="element-658" data-mp="19dzdv3imfd8e">
                {page + 1} van {totalPages}
              </p>

              <button onClick={nextPage} className="p-2 rounded-full bg-[#F7F8FA] hover:bg-[#007AFF] hover:text-white transition-colors flex-shrink-0" aria-label="Volgende reviews" data-id="element-659" data-mp="1eb92igy6rkv6">
                <ArrowRightIcon className="h-5 w-5" data-id="element-660" data-mp="qgpv7ol4e3s7" />
              </button>
            </div>}

          <div className="flex flex-wrap justify-center gap-4 mt-10" data-id="element-661" data-mp="vfsns9jwyhja">
            {GOOGLE_REVIEWS_URL && <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-white border-2 border-[#007AFF] text-[#007AFF] hover:bg-[#007AFF] hover:text-white font-medium py-3 px-6 rounded-xl transition duration-300" data-id="element-662" data-mp="2kuz31q9o9by7">
                Lees alle reviews op Google
                <ExternalLinkIcon className="h-4 w-4 ml-2" data-id="element-663" data-mp="2eegx9ffxdo7o" />
              </a>}
            <a href="/#client-cases" className="inline-flex items-center bg-[#007AFF] hover:bg-[#005FCC] text-white font-medium py-3 px-6 rounded-xl transition duration-300" data-id="element-664" data-mp="2acvmq0qv5m0n">
              Bekijk onze klantcases
              <ArrowRightIcon className="h-4 w-4 ml-2" data-id="element-665" data-mp="325ckdz9frv8l" />
            </a>
          </div>
        </div>
      </div>
    </div>;
};